//basicinformation.tsx

import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useState
} from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
    TextField,
    Typography,
    Checkbox,
    FormControlLabel,
    InputLabel,
    CircularProgress,
    InputAdornment
} from "@mui/material";
import Grid from "@mui/material/Grid2";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Dayjs } from "dayjs";
import dayjs from "dayjs";

import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const mmGstOptions = {
    "29AAOCM1140N1Z2 - Karnataka": {
        address:
            "Building No.757, 2nd Floor, 100 Feet Rd, HAL 2nd Stage, Appareddipalya, Indiranagar, Bengaluru, Karnataka 560038"
    },

    "33AAOCM1140N1ZD - Tamilnadu": {
        address:
            "Sixth Floor, 37/21, 23 & 24/21, 24/22, Chamiers Tower, Chamiers Road, Teynampet, Chennai, Chennai, Tamil Nadu, 600018."
    }
};

export const BasicInformation = forwardRef((props: any, ref) => {
    const location = useLocation();
    const rfqData = location.state?.rfqData;
    // const corfqId = rfqData?.rfqID || "";
    // const CORFQ_ID = rfqData?.ID || "";
    // const companyID = rfqData?.companyID || "";
    // const keyAccountManager = rfqData?.keyAccountManager || "";

    const corfqId =
        rfqData?.rfqID || sessionStorage.getItem("temp_copo_display_id") || "";
    const [corfqIdInternalState, setCorfqIdInternalState] = useState(
        rfqData?.ID || sessionStorage.getItem("temp_copo_CORFQ_ID") || ""
    );
    const [companyIdState, setCompanyIdState] = useState(
        rfqData?.companyID ||
            sessionStorage.getItem("temp_copo_companyID") ||
            ""
    );
    const [keyAccountManagerState, setKeyAccountManagerState] = useState(
        rfqData?.keyAccountManager ||
            sessionStorage.getItem("temp_copo_keyAccountManager") ||
            ""
    );

    const [companyName, setCompanyName] = useState("");
    const [corfqIdState, setCorfqIdState] = useState("");

    const [mmGst, setMmGst] = React.useState("");
    const [mmAddress, setMmAddress] = useState("");

    const [billingAddress, setBillingAddress] = useState("");
    const [deliveryAddress, setDeliveryAddress] = useState("");
    const [sameAsBilling, setSameAsBilling] = useState(false);
    const [copoNumber, setCopoNumber] = useState("");
    const [copoDate, setCopoDate] = useState<Dayjs | null>(null);

    /* Removed duplicate state */

    const [errors, setErrors] = useState({
        mmGst: "",
        deliveryAddress: "",
        copoNumber: "",
        copoDate: ""
    });

    const validateBasicInfo = () => {
        let valid = true;

        const newErrors = {
            mmGst: "",
            deliveryAddress: "",
            copoNumber: "",
            copoDate: ""
        };

        if (!mmGst) {
            newErrors.mmGst = "GST Number is required";
            valid = false;
        }

        if (!deliveryAddress.trim()) {
            newErrors.deliveryAddress = "Delivery Address is required";
            valid = false;
        }

        if (!copoNumber.trim()) {
            newErrors.copoNumber = "COPO number is required";
            valid = false;
        }

        if (!copoDate) {
            newErrors.copoDate = "COPO date is required";
            valid = false;
        }

        setErrors(newErrors);
        return valid;
    };

    useImperativeHandle(ref, () => ({
        validate: validateBasicInfo,
        getData: () => ({
            // CORFQ_ID,
            // companyID,
            // keyAccountManager,
            CORFQ_ID: corfqIdInternalState,
            companyID: companyIdState,
            keyAccountManager: keyAccountManagerState,
            companyName: companyName,
            corfqId: corfqIdState,
            mmGst,
            mmAddress,
            billingAddress,
            deliveryAddress,
            copoNumber,
            copoDate: copoDate ? copoDate.format("DD-MMM-YYYY HH:mm:ss") : null,
            sameAsBilling
        })
    }));

    const handleChange = (event) => {
        props.setIsFormTouched?.(true);
        const selectedKey = event.target.value;
        setMmGst(selectedKey);
        setMmAddress(mmGstOptions[selectedKey].address);

        setErrors((prev) => ({ ...prev, mmGst: "" }));
    };

    const handleSameAsBilling = (event) => {
        props.setIsFormTouched?.(true);
        const checked = event.target.checked;
        setSameAsBilling(checked);

        if (checked) {
            setDeliveryAddress(billingAddress); // auto-fill
        }
        if (billingAddress.trim()) {
            setErrors((prev) => ({ ...prev, deliveryAddress: "" }));
        }
    };

    /* eslint-disable */
    const storedData = useSelector(
        (state: any) => state.CoPoReducer.basicInfoFormData
    );
    const autoPopulateData = useSelector(
        (state: any) => state.CoPoReducer.autoPopulateData
    );
    /* eslint-enable */

    useEffect(() => {
        let currentBillingAddress = ""; // Initialize to empty string
        let currentCompanyName = "";
        let currentCorfqId = "";

        // 1. Hydrate from Redux if data exists
        if (storedData?.mmGst) {
            setMmGst(storedData.mmGst || "");
            setMmAddress(storedData.mmAddress || "");
            currentBillingAddress = storedData.billingAddress || ""; // Update currentBillingAddress
            setBillingAddress(currentBillingAddress);
            setDeliveryAddress(storedData.deliveryAddress || "");
            setCopoNumber(storedData.copoNumber || "");
            setCopoDate(
                storedData.copoDate ? dayjs(storedData.copoDate) : null
            );
            setSameAsBilling(storedData.sameAsBilling || false);
            currentCompanyName = storedData.companyName || "";
            setCompanyName(currentCompanyName);
            currentCorfqId = storedData.corfqId || "";
            setCorfqIdState(currentCorfqId);
        } else {
            // Fallback to location state if available
            // currentCompanyName = rfqData?.companyName || "";
            currentCompanyName =
                rfqData?.companyName ||
                sessionStorage.getItem("temp_copo_companyName") ||
                "";
            setCompanyName(currentCompanyName);
            currentCorfqId = corfqId || "";
            setCorfqIdState(currentCorfqId);
        }

        // 2. Autopopulate from API
        // Check if currentBillingAddress is still empty after Redux hydration
        if (!currentBillingAddress && autoPopulateData?.CORFQRes) {
            const res = autoPopulateData.CORFQRes;

            const street = res["Company_Name.Address_Street"] || "";
            const city = res["Company_Name.Address_City"] || "";
            const state = res["Company_Name.Address_State"] || "";
            const country = res["Company_Name.Address_Country"] || "";
            const code = res["Company_Name.Address_Code"] || "";

            const fullAddress = [street, city, state, country]
                .filter((part) => part && String(part).trim() !== "")
                .join(", ");

            const combinedAddress = code
                ? `${fullAddress} - ${code}`
                : fullAddress;

            if (combinedAddress) {
                setBillingAddress(combinedAddress);
                // Also update delivery address if "Same as billing" is checked
                if (sameAsBilling || storedData?.sameAsBilling) {
                    setDeliveryAddress(combinedAddress);
                }
            }

            // CORFQ Internal ID fallback from autopopulate
            if (!corfqIdInternalState) {
                const iId = res["ID"];
                if (iId) setCorfqIdInternalState(iId);
            }

            // Company ID fallback from autopopulate
            if (!companyIdState) {
                const cId = res["Company_Name.ID"];
                if (cId) setCompanyIdState(cId);
            }

            // Key Account Manager fallback from autopopulate
            if (!keyAccountManagerState) {
                // Extract from object if present, otherwise string
                const kam =
                    typeof res["Key_Account_Manager"] === "object"
                        ? res["Key_Account_Manager"]?.Name ||
                          res["Key_Account_Manager"]?.zc_display_value
                        : res["Key_Account_Manager"];
                if (kam) setKeyAccountManagerState(kam);
            }

            // Company Name
            if (!currentCompanyName) {
                const cName = res["Company_Name.Company_Name"];
                if (cName) setCompanyName(cName);
            }
            // CORFQ ID
            if (!currentCorfqId) {
                const cId = res["RFQ_No"];
                if (cId) setCorfqIdState(cId);
            }
        }
    }, [storedData, autoPopulateData, sameAsBilling]);

    return (
        <>
            <Typography variant="h6" mb={3}>
                Basic Information
            </Typography>

            <Grid container spacing={2}>
                <Grid size={{ md: 4, xs: 12 }} mb={2}>
                    <TextField
                        fullWidth
                        disabled
                        label="Name of the Company"
                        value={companyName}
                    />
                </Grid>
                <Grid size={{ md: 4, xs: 12 }}>
                    <TextField
                        fullWidth
                        label="CORFQ ID"
                        disabled
                        value={corfqIdState}
                    />
                </Grid>

                <Grid size={{ md: 4, xs: 12 }} mb={2}>
                    <TextField
                        fullWidth
                        label={
                            <>
                                COPO Number{" "}
                                <span style={{ color: "red" }}>*</span>
                            </>
                        }
                        value={copoNumber}
                        onInput={(e: React.FormEvent<HTMLInputElement>) => {
                            props.setIsFormTouched?.(true);
                            const input = e.target as HTMLInputElement;
                            const newValue = input.value.replace(
                                /[^A-Za-z0-9]/g,
                                ""
                            );
                            input.value = newValue;
                            setCopoNumber(newValue);
                            if (newValue) {
                                setErrors((prev) => ({
                                    ...prev,
                                    copoNumber: ""
                                }));
                            }
                        }}
                        error={Boolean(errors.copoNumber)}
                        helperText={errors.copoNumber}
                    />
                </Grid>

                <Grid size={{ md: 4, xs: 12 }} mb={2}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            sx={{ minWidth: "100%" }}
                            label={
                                <>
                                    COPO date{" "}
                                    <span style={{ color: "red" }}>*</span>
                                </>
                            }
                            value={copoDate}
                            onChange={(newValue) => {
                                props.setIsFormTouched?.(true);
                                setCopoDate(newValue);
                                if (newValue) {
                                    setErrors((prev) => ({
                                        ...prev,
                                        copoDate: ""
                                    }));
                                }
                            }}
                            maxDate={dayjs()}
                            slotProps={{
                                field: {
                                    readOnly: true // This stops arrow increment
                                },
                                textField: {
                                    error: Boolean(errors.copoDate)
                                }
                            }}
                        />
                    </LocalizationProvider>
                    {errors.copoDate && (
                        <Typography color="error" fontSize={12}>
                            {errors.copoDate}
                        </Typography>
                    )}
                </Grid>

                <Grid size={{ md: 4, xs: 12 }}>
                    <FormControl fullWidth error={Boolean(errors.mmGst)}>
                        <InputLabel id="demo-simple-select-label">
                            MM GST Number{" "}
                            <span style={{ color: "red" }}>*</span>
                        </InputLabel>

                        <Select
                            value={mmGst}
                            onChange={handleChange}
                            label={
                                <>
                                    MM GST Number
                                    <span style={{ color: "red" }}>*</span>
                                </>
                            }
                        >
                            {Object.entries(mmGstOptions).map(([key]) => (
                                <MenuItem key={key} value={key}>
                                    {key}
                                </MenuItem>
                            ))}
                        </Select>
                        {errors.mmGst && (
                            <Typography color="error" fontSize={12}>
                                {errors.mmGst}
                            </Typography>
                        )}
                    </FormControl>
                </Grid>
                <Grid size={{ md: 4, xs: 12 }}>
                    {/* <TextField fullWidth label="Name to Bill" defaultValue="" /> */}
                </Grid>
                <Grid size={{ md: 4, xs: 12 }}>
                    <TextField
                        fullWidth
                        disabled
                        label="Machinemaze Address"
                        multiline
                        rows={3}
                        value={mmAddress}
                    />
                </Grid>

                <Grid size={{ md: 4, xs: 12 }}>
                    <TextField
                        fullWidth
                        label="Billing Address"
                        multiline
                        inputProps={{ maxLength: 1000 }}
                        rows={3}
                        disabled
                        value={billingAddress}
                        placeholder={
                            props?.isAutoPopulateLoading
                                ? "Fetching billing address..."
                                : ""
                        }
                        helperText={
                            props?.isAutoPopulateLoading
                                ? "Billing address is loading from CORFQ details."
                                : ""
                        }
                        onChange={(e) => {
                            setBillingAddress(e.target.value);
                            if (sameAsBilling) {
                                setDeliveryAddress(e.target.value); // auto-update delivery when linked
                            }
                        }}
                        InputProps={{
                            endAdornment: props?.isAutoPopulateLoading ? (
                                <InputAdornment position="end">
                                    <CircularProgress size={16} />
                                </InputAdornment>
                            ) : undefined
                        }}
                    />
                </Grid>

                <Grid size={{ md: 4, xs: 12 }}>
                    <TextField
                        fullWidth
                        label={
                            <>
                                Delivery Address
                                <span style={{ color: "red" }}>*</span>
                            </>
                        }
                        multiline
                        inputProps={{ maxLength: 1000 }}
                        rows={3}
                        disabled={sameAsBilling}
                        value={deliveryAddress}
                        onChange={(e) => {
                            props.setIsFormTouched?.(true);
                            const value = e.target.value;
                            setDeliveryAddress(value);
                            if (value.trim()) {
                                setErrors((prev) => ({
                                    ...prev,
                                    deliveryAddress: ""
                                }));
                            }
                        }}
                        error={Boolean(errors.deliveryAddress)}
                        helperText={errors.deliveryAddress}
                    />

                    <FormControlLabel
                        label="Same as billing address"
                        control={
                            <Checkbox
                                checked={sameAsBilling}
                                disabled={billingAddress === ""}
                                onChange={handleSameAsBilling}
                            />
                        }
                    />
                </Grid>
            </Grid>
        </>
    );
});
